import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

export async function submitContact(payload) {
  const { data } = await api.post("/contact", payload);
  return data;
}

export async function requestDiagnostic(payload) {
  const { data } = await api.post("/diagnostic/request", payload);
  return data;
}

export function diagnosticPdfUrl() {
  return `${API}/diagnostic/download`;
}

export async function fetchArticles() {
  const { data } = await api.get("/articles");
  return data;
}

export async function fetchArticle(slug) {
  const { data } = await api.get(`/articles/${slug}`);
  return data;
}
